<div class="text-left">
    <img src="https://iti-images.s3.amazonaws.com/imgs/ai-star.gif" alt="" width="20">

      <span (click)="onGenerateDescription()" class="text-[#3476d2] cursor-pointer hover:underline">
        <span *ngIf="!isGenerating&&!aiGeneratedDescs.length" class="text-sm cursor-pointer"
        matTooltip="Using AI to generate an introduction for this event">
        Try our AI Content Assistant
        </span>
      </span>

      <ng-container *ngIf="aiGeneratedDescs.length&&!isGenerating">
        <span (click)="showPreview()" class="text-sm cursor-pointer text-[#3476d2] hover:underline">
            Description generated, click to select.
          </span>
        <span href="" class="text-sm cursor-pointer ml-3 text-[#3476d2] hover:underline"
            (click)="onGenerateDescription()">Generate again.
        </span>
      </ng-container>
      
      
      <!-- <mat-icon *ngIf="aiGeneratedDescs.length&&!isGenerating" matTooltip="Generate again"
        (click)="onGenerateDescription()" class="!w-4 !h-4 !leading-4 !text-sm">autorenew</mat-icon> -->

      <ng-container *ngIf="isGenerating">
        <span class="text-[#3476d2] cursor-pointer hover:underline">
            <span class="text-sm">Generating...</span>
            <mat-icon matTooltip="Generating..." class="ig-spin !w-4 !h-4 !leading-4 !text-sm">autorenew</mat-icon>
        </span>
      </ng-container>

    <span *ngIf="isPlace" (click)="bulkGenerateDescriptions()" class="text-sm cursor-pointer ml-3 text-[#3476d2] hover:underline">Bulk Generation</span>
  </div>